import { createApi } from '@reduxjs/toolkit/query/react';

import { createApiBaseQuery, Methods } from '../shared';

import { AI_OPERATOR_CONFIG_CHUNK } from './const';
import {
  AiOperatorConfigEndpoints as Endpoints,
  type GetAiOperatorConfigRequest,
  type GetAiOperatorConfigResponse,
  type GetDefaultProfileRequest,
  type GetDefaultProfileResponse,
  type UpdateAiOperatorConfigRequest,
  type UpdateAiOperatorConfigResponse,
} from './types';

export const aiOperatorConfigApi = createApi({
  reducerPath: 'aiOperatorConfigApi',
  baseQuery: createApiBaseQuery(AI_OPERATOR_CONFIG_CHUNK),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.Get]: query<
      GetAiOperatorConfigResponse,
      GetAiOperatorConfigRequest
    >({
      query: (params) => ({
        url: Endpoints.Get,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.Update]: mutation<
      UpdateAiOperatorConfigResponse,
      UpdateAiOperatorConfigRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.Update,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetDefaultProfile]: query<
      GetDefaultProfileResponse,
      GetDefaultProfileRequest
    >({
      query: (params) => ({
        url: Endpoints.GetDefaultProfile,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useGetQuery: useGetAiOperatorConfigQuery,
  useLazyGetQuery: useLazyGetAiOperatorConfigQuery,
  useUpdateMutation: useUpdateAiOperatorConfigMutation,
  useGetDefaultProfileQuery,
  useLazyGetDefaultProfileQuery,
} = aiOperatorConfigApi;
